import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header.jsx"
import Lastra from "../../Assets/Lastra.png";
import Qilxy from "../../Assets/Qilxy.png";
import Coffee from "../../Assets/Buymeacoffee.svg"
import style from "./style.module.css";

const Home = () => {

    const navigate = useNavigate();

    return (
        <div className={style.rootDiv}>
            <Header />
            <div className={style.contentDiv}>
                <h1>LASTRA</h1>
                <p><b>WHERE EVERY GAME THRIVES</b></p>
                <p>by <b>Qilxy</b></p>
            </div>
            <div className={style.footerDiv}>
                <h1>ABOUT US</h1>
                <p className={style.article}>Qilxy focuses on creating websites that are both functional and visually appealing. We handle everything from design to deployment to ensure your online presence is just right. Meanwhile, Lastra, a part of Qilxy, offers engaging game servers for Minecraft, Rust, and other exciting games. Whether you're seeking an impressive website or a vibrant gaming community, Qilxy and Lastra provide reliable and enjoyable solutions.</p>
                <div className={style.footer}>
                    <h1>CONTACT US</h1>
                    <h1>FOLLOW & SUPPORT</h1>
                    <h1>OUR COMPANY</h1>
                    <div className={style.contacts}>
                        <svg viewBox="0 0 512 512">
                            <path d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"/>
                        </svg>
                        <p>lastrabyqilxy@gmail.com</p>
                    </div>
                    <div className={style.socials}>
                        <svg onClick={() => window.location.href = "https://www.instagram.com/lastra_qilxy"} viewBox="0 0 448 512">
                            <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
                        </svg>
                        <img onClick={() => window.location.href = "https://buymeacoffee.com/lastra"} src={Coffee} alt="Buy me a coffee"/>
                    </div>
                    <div className={style.company}>
                        <img onClick={() => window.location.href = "https://mylastra.com"} src={Lastra} alt="Lastra Logo"/>
                        <img onClick={() => window.location.href = "https://qilxy.com"} src={Qilxy} alt="Qilxy Logo"/>
                    </div>
                    <div className={style.spacer}></div>
                    <p className={style.rights}> Copyright 2024 Qilxy. All Rights Reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default Home;